import { generateDynamicPath } from 'common/utils/routing';

export const NatalieRoutes = {
  Natalie: '/natalie',
  BeforeJoin: '/natalie/:id/before-join',
  Configure: '/natalie/:id/configure',
  Details: '/natalie/:id',
  Feedback: '/natalie/:id/feedback',
  Join: '/natalie/:id/join',
  List: '/natalie/list',
  Public: '/natalie/:id/public',
  Room: '/natalie/:id/room',
  RoomLiveKit: '/natalie/:id/room/livekit',
  WaitingRoom: '/natalie/:id/waiting-room',
  Wizard: '/natalie/wizard/:id?',
};

export const NataliePublicRoutes = [NatalieRoutes.Public, NatalieRoutes.Details];

// Routes where Intercom widget should be hidden (natalie module)
export const INTERCOM_HIDDEN_ROUTES: readonly string[] = [
  // Live Natalie routes
  NatalieRoutes.BeforeJoin,
  NatalieRoutes.Configure,
  NatalieRoutes.Join,
  NatalieRoutes.Room,
  NatalieRoutes.WaitingRoom,
  // Public routes
  ...NataliePublicRoutes,
];

// Routes where Intercom should be shown to anonymous (unauthenticated) users (natalie module)
export const INTERCOM_PUBLIC_ROUTES: readonly string[] = [NatalieRoutes.Public];

export const getNatalieDetailsPath = (id: string) => generateDynamicPath(NatalieRoutes.Details, { id });

export const getNataliePublicPath = (id: string) =>
  generateDynamicPath(NatalieRoutes.Public, { id }, undefined, { isAbsolute: true });

export const getNatalieFeedbackPath = (id: string) => generateDynamicPath(NatalieRoutes.Feedback, { id });
